// import React, { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const ProjectDetails = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     // Safely reads the project object passed from state
//     const project = location.state?.project;

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, [project]);

//     // Fallback View if the page is direct-refreshed without state
//     if (!project) {
//         return (
//             <div style={{ padding: '120px 20px', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
//                 <h2 style={{ fontWeight: '400', color: '#2C302E' }}>Project details not found</h2>
//                 <button 
//                     onClick={() => navigate('/')} 
//                     style={{ 
//                         marginTop: '20px',
//                         padding: '12px 30px',
//                         backgroundColor: '#2C302E',
//                         color: '#FFF',
//                         border: 'none',
//                         borderRadius: '30px',
//                         cursor: 'pointer'
//                     }}
//                 >
//                     Back to Projects
//                 </button>
//             </div>
//         );
//     }

//     const styles = {
//         container: {
//             maxWidth: '1300px',
//             margin: '0 auto',
//             padding: '40px 4% 100px 4%',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             color: '#2C302E',
//             backgroundColor: '#FFFFFF'
//         },
//         navBar: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'flex-start',
//             marginBottom: '50px',
//             gap: '20px'
//         },
//         backBtn: {
//             background: 'none',
//             border: 'none',
//             fontSize: '0.95rem',
//             color: '#7A807E',
//             cursor: 'pointer',
//             padding: 0,
//             fontWeight: '500'
//         },
//         headerMeta: {
//             width: '100%',
//             textAlign: 'center'
//         },
//         title: {
//             fontSize: '2.6rem',
//             fontWeight: '300',
//             textTransform: 'uppercase',
//             margin: '0 0 6px 0',
//             letterSpacing: '2px'
//         },
//         subtitle: {
//             fontSize: '0.9rem',
//             color: '#7A807E',
//             textTransform: 'uppercase',
//             letterSpacing: '1.5px',
//             margin: 0
//         },
//         masonryGrid: {
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 450px), 1fr))',
//             gap: '30px'
//         },
//         imageFrame: {
//             overflow: 'hidden',
//             backgroundColor: '#FAF9F6',
//             height: '480px'
//         },
//         image: {
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             display: 'block'
//         },
//         footer: {
//             marginTop: '90px',
//             padding: '60px 20px',
//             display: 'flex',
//             justifyContent: 'center',
//             backgroundColor: '#FAF9F6'
//         },
//         footerInner: {
//             maxWidth: '750px',
//             textAlign: 'center'
//         },
//         description: {
//             fontSize: '1.05rem',
//             lineHeight: '1.8',
//             color: '#4A504E',
//             fontWeight: '300',
//             marginBottom: '35px'
//         },
//         divider: {
//             width: '60px',
//             height: '1px',
//             background: '#2C302E',
//             margin: '0 auto 35px auto',
//             opacity: 0.2
//         },
//         actionBtn: {
//             padding: '14px 40px',
//             fontSize: '1rem',
//             fontWeight: '600',
//             color: '#FFFFFF',
//             backgroundColor: '#2C302E',
//             border: 'none',
//             borderRadius: '30px',
//             cursor: 'pointer',
//             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
//             transition: 'all 0.2s ease',
//             textTransform: 'uppercase',
//             letterSpacing: '1px'
//         }
//     };

//     return (
//         <div style={styles.container}>
//             <div style={styles.navBar}>
//                 <button 
//                     style={styles.backBtn} 
//                     onClick={() => navigate(-1)} 
//                     onMouseEnter={(e) => e.target.style.color = '#2C302E'}
//                     onMouseLeave={(e) => e.target.style.color = '#7A807E'}
//                 >
//                     ← Back to Projects
//                 </button>
//                 <div style={styles.headerMeta}>
//                     <h1 style={styles.title}>{project.title}</h1>
//                     <p style={styles.subtitle}>{project.category} — {project.location}</p>
//                 </div>
//             </div>

//             {/* Render out the parsed sub-images layout dynamically */}
//             <div style={styles.masonryGrid}>
//                 {project.gallery && project.gallery.map((imgUrl, i) => (
//                     <div key={i} style={styles.imageFrame}>
//                         <img style={styles.image} src={imgUrl} alt={`${project.title} block`} loading="lazy" />
//                     </div>
//                 ))}
//             </div>

//             <section style={styles.footer}>
//                 <div style={styles.footerInner}>
//                     <p style={styles.description}>{project.description}</p>
//                     <div style={styles.divider} />
//                     {/* <button 
//                         style={styles.actionBtn}
//                         onClick={() => navigate(-1)}
//                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#111211'}
//                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2C302E'}
//                     >
//                         Return to Main Portfolio
//                     </button> */}
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default ProjectDetails;

// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';

// const DETAILED_PROJECTS_DATABASE = [
//     {
//         id: 1,
//         title: 'The Crisp Living',
//         category: 'Residential',
//         location: 'Mumbai',
//         image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//         gallery: [
//             'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1617806118233-18e1db207f62?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?auto=format&fit=crop&w=800&q=80'
//         ],
//         description: 'A thoughtful architectural project balance combining raw texturing metrics with functional sleek lines. Strategically designed to allow natural lumens to interact beautifully with customized timber implementations across all central living blocks.'
//     }
// ];

// const ProjectDetails = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [project, setProject] = useState(null);
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//     useEffect(() => {
//         window.scrollTo(0, 0);

//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         window.addEventListener('resize', handleResize);

//         if (location.state?.project) {
//             setProject(location.state.project);
//         } else if (id) {
//             const found = DETAILED_PROJECTS_DATABASE.find(p => p.id === parseInt(id, 10));
//             if (found) setProject(found);
//         } else {
//             setProject(DETAILED_PROJECTS_DATABASE[0]);
//         }

//         return () => window.removeEventListener('resize', handleResize);
//     }, [location.state, id]);

//     if (!project) return null;

//     const styles = {
//         container: {
//             maxWidth: '1400px',
//             margin: '0 auto',
//             padding: '60px 4% 120px 4%',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             color: '#2C302E',
//             backgroundColor: '#FFFFFF'
//         },
//         navBar: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'flex-start',
//             marginBottom: '60px',
//             gap: '16px'
//         },
//         backBtn: {
//             background: 'none',
//             border: 'none',
//             fontSize: '0.85rem',
//             color: '#7A807E',
//             cursor: 'pointer',
//             padding: 0,
//             fontWeight: '600',
//             textTransform: 'uppercase',
//             letterSpacing: '1.5px',
//             transition: 'color 0.2s ease'
//         },
//         headerMeta: {
//             width: '100%',
//             textAlign: 'center',
//             marginTop: '10px'
//         },
//         title: {
//             fontSize: isMobile ? '2rem' : '2.8rem',
//             fontWeight: '300',
//             textTransform: 'uppercase',
//             margin: '0 0 8px 0',
//             letterSpacing: '3px',
//             lineHeight: '1.2'
//         },
//         subtitle: {
//             fontSize: '0.85rem',
//             color: '#7A807E',
//             textTransform: 'uppercase',
//             letterSpacing: '2px',
//             margin: 0
//         },
//         // Asymmetric Editorial Grid configuration
//         editorialGrid: {
//             display: 'grid',
//             gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//             gap: isMobile ? '20px' : '40px',
//             width: '100%'
//         },
//         imageFrame: (index) => {
//             // Editorial Pattern Logic: Every 3rd image spans completely full-width horizontally
//             const isFullWidth = !isMobile && index % 3 === 0;
//             return {
//                 gridColumn: isFullWidth ? 'span 2' : 'span 1',
//                 height: isFullWidth ? (isMobile ? '300px' : '650px') : (isMobile ? '350px' : '520px'),
//                 overflow: 'hidden',
//                 backgroundColor: '#FAF9F6',
//                 position: 'relative',
//                 boxShadow: '0 4px 15px rgba(0,0,0,0.02)'
//             };
//         },
//         image: {
//             width: '100%',
//             height: '100%',
//             objectFit: 'contain',
//             display: 'block',
//             transition: 'transform 0.6s ease'
//         },
//         footerSection: {
//             marginTop: '100px',
//             padding: '80px 20px',
//             display: 'flex',
//             justifyContent: 'center',
//             backgroundColor: '#FAF9F6',
//             borderRadius: '4px'
//         },
//         footerInner: {
//             maxWidth: '700px',
//             textAlign: 'center'
//         },
//         description: {
//             fontSize: '1.05rem',
//             lineHeight: '1.85',
//             color: '#4A504E',
//             fontWeight: '300',
//             marginBottom: '40px'
//         },
//         divider: {
//             width: '40px',
//             height: '1px',
//             background: '#2C302E',
//             margin: '0 auto 40px auto',
//             opacity: 0.2
//         },
//         actionBtn: {
//             padding: '14px 40px',
//             fontSize: '0.9rem',
//             fontWeight: '600',
//             color: '#FFFFFF',
//             backgroundColor: '#2C302E',
//             border: 'none',
//             borderRadius: '30px',
//             cursor: 'pointer',
//             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//             transition: 'all 0.2s ease',
//             textTransform: 'uppercase',
//             letterSpacing: '1.5px',
//             outline: 'none'
//         }
//     };

//     return (
//         <div style={styles.container}>
//             {/* Top Navigation Panel */}
//             <div style={styles.navBar}>
//                 <button
//                     style={styles.backBtn}
//                     onClick={() => navigate('/')}
//                     onMouseEnter={(e) => e.target.style.color = '#2C302E'}
//                     onMouseLeave={(e) => e.target.style.color = '#7A807E'}
//                 >
//                     ← Back to Projects
//                 </button>
//                 <div style={styles.headerMeta}>
//                     <h1 style={styles.title}>{project.title}</h1>
//                     <p style={styles.subtitle}>{project.category} — {project.location}</p>
//                 </div>
//             </div>

//             {/* Asymmetric Structural Grid Stream */}
//             <div style={styles.editorialGrid}>
//                 {project.gallery && project.gallery.map((imgUrl, i) => (
//                     <div
//                         key={i}
//                         style={styles.imageFrame(i)}
//                         onMouseEnter={(e) => {
//                             const img = e.currentTarget.querySelector('img');
//                             if (img) img.style.transform = 'scale(1.02)';
//                         }}
//                         onMouseLeave={(e) => {
//                             const img = e.currentTarget.querySelector('img');
//                             if (img) img.style.transform = 'scale(1)';
//                         }}
//                     >
//                         <img
//                             style={styles.image}
//                             src={imgUrl}
//                             alt={`${project.title} gallery slot ${i + 1}`}
//                             loading="lazy"
//                         />
//                     </div>
//                 ))}
//             </div>

//             {/* Narrative Briefing Footer Card */}
//             <section style={styles.footerSection}>
//                 <div style={styles.footerInner}>
//                     <p style={styles.description}>{project.description}</p>
//                     <div style={styles.divider} />
//                     {/* <button
//                         style={styles.actionBtn}
//                         onClick={() => navigate('/')}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'scale(1.02)';
//                             e.currentTarget.style.backgroundColor = '#111211';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'scale(1)';
//                             e.currentTarget.style.backgroundColor = '#2C302E';
//                         }}
//                     >
//                         Return to Main Portfolio
//                     </button> */}
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default ProjectDetails;


// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate, useParams } from 'react-router-dom';

// const DETAILED_PROJECTS_DATABASE = [
//     {
//         id: 1,
//         title: 'Yugen',
//         category: 'Residential',
//         location: 'Pune',
//         image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//         gallery: [
//             'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1617806118233-18e1db207f62?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80',
//             'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=800&q=80'
//         ],
//         description: 'Living in closeness to nature, minimalist philosophy, and emotional depth. Features clean curves, custom architectural entryways, and soft lighting textures paired with bespoke wooden integrations.'
//     }
// ];

// const ProjectDetails = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [project, setProject] = useState(null);
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//     useEffect(() => {
//         window.scrollTo(0, 0);

//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         window.addEventListener('resize', handleResize);

//         if (location.state?.project) {
//             setProject(location.state.project);
//         } else if (id) {
//             const found = DETAILED_PROJECTS_DATABASE.find(p => p.id === parseInt(id, 10));
//             if (found) setProject(found);
//         } else {
//             setProject(DETAILED_PROJECTS_DATABASE[0]);
//         }

//         return () => window.removeEventListener('resize', handleResize);
//     }, [location.state, id]);

//     if (!project) return null;

//     // Helper logic to group the flat gallery array into structured row buckets matching the Yugen design
//     const createEditorialRows = (images) => {
//         const rows = [];
//         let i = 0;
//         let rowPatternIndex = 0; // Toggles between Row types

//         while (i < images.length) {
//             if (rowPatternIndex % 3 === 0) {
//                 // Type A Row: 1/3 Left, 2/3 Right (Needs 2 images)
//                 rows.push({ type: 'split-left', items: images.slice(i, i + 2) });
//                 i += 2;
//             } else if (rowPatternIndex % 3 === 1) {
//                 // Type B Row: 2/3 Left, 1/3 Right (Needs 2 images)
//                 rows.push({ type: 'split-right', items: images.slice(i, i + 2) });
//                 i += 2;
//             } else {
//                 // Type C Row: Triple Column Equal Grid (Needs 3 images)
//                 rows.push({ type: 'triple', items: images.slice(i, i + 3) });
//                 i += 3;
//             }
//             rowPatternIndex++;
//         }
//         return rows;
//     };

//     const galleryRows = createEditorialRows(project.gallery || []);

//     const styles = {
//         wrapper: {
//             backgroundColor: '#FFFFFF',
//             width: '100%',
//             minHeight: '100vh',
//             fontFamily: 'system-ui, -apple-system, sans-serif'
//         },
//         container: {
//             maxWidth: '1440px',
//             margin: '0 auto',
//             padding: isMobile ? '20px 12px 60px 12px' : '40px 60px 100px 60px'
//         },
//         headerMeta: {
//             textAlign: 'center',
//             marginBottom: isMobile ? '30px' : '60px'
//         },
//         title: {
//             fontSize: isMobile ? '2rem' : '3.2rem',
//             fontWeight: '300',
//             textTransform: 'uppercase',
//             margin: '0 0 4px 0',
//             color: '#111111',
//             letterSpacing: '4px'
//         },
//         subtitle: {
//             fontSize: '0.8rem',
//             color: '#777777',
//             textTransform: 'uppercase',
//             letterSpacing: '3px',
//             margin: 0
//         },
//         streamDeck: {
//             display: 'flex',
//             flexDirection: 'column',
//             gap: isMobile ? '12px' : '24px',
//             width: '100%'
//         },
//         // Row Structure Container Base Styles
//         rowBase: {
//             display: 'grid',
//             gap: isMobile ? '12px' : '24px',
//             width: '100%'
//         },
//         imageFrame: {
//             width: '100%',
//             height: isMobile ? '280px' : '540px', // Uniform row height limits matching high-end look
//             overflow: 'hidden',
//             backgroundColor: '#F9F9F8'
//         },
//         image: {
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             display: 'block'
//         },
//         footerSection: {
//             marginTop: isMobile ? '50px' : '80px',
//             padding: isMobile ? '30px 10px' : '50px 20px',
//             textAlign: 'center'
//         },
//         description: {
//             fontSize: '1.05rem',
//             lineHeight: '1.8',
//             color: '#444444',
//             fontWeight: '300',
//             maxWidth: '750px',
//             margin: '0 auto 40px auto',
//             letterSpacing: '0.3px'
//         },
//         actionBtn: {
//             padding: '12px 40px',
//             fontSize: '0.8rem',
//             fontWeight: '600',
//             color: '#FFFFFF',
//             backgroundColor: '#111111',
//             border: 'none',
//             cursor: 'pointer',
//             textTransform: 'uppercase',
//             letterSpacing: '2px',
//             transition: 'background-color 0.2s ease'
//         }
//     };

//     return (
//         <div style={styles.wrapper}>
//             <div style={styles.container}>

//                 {/* Header Section */}
//                 <div style={styles.headerMeta}>
//                     <h1 style={styles.title}>{project.title}</h1>
//                     <p style={styles.subtitle}>{project.category} // {project.location}</p>
//                 </div>

//                 {/* Structured Architectural Grid Layout Stream */}
//                 <div style={styles.streamDeck}>
//                     {galleryRows.map((row, rowIndex) => {

//                         // Determine Grid column allocations dynamically based on your row models
//                         let gridTemplateColumns = '1fr';
//                         if (!isMobile) {
//                             if (row.type === 'split-left') gridTemplateColumns = '1.1fr 2fr'; // 1/3 narrow and 2/3 wide
//                             if (row.type === 'split-right') gridTemplateColumns = '2fr 1.1fr'; // 2/3 wide and 1/3 narrow
//                             if (row.type === 'triple') gridTemplateColumns = '1fr 1fr 1fr';    // 3 equal columns
//                         }

//                         return (
//                             <div key={rowIndex} style={{ ...styles.rowBase, gridTemplateColumns }}>
//                                 {row.items.map((imgUrl, imgIndex) => (
//                                     <div key={imgIndex} style={styles.imageFrame}>
//                                         <img
//                                             style={styles.image}
//                                             src={imgUrl}
//                                             alt={`Gallery slot item`}
//                                             loading="lazy"
//                                         />
//                                     </div>
//                                 ))}
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {/* Bottom Description Section */}
//                 <section style={styles.footerSection}>
//                     <p style={styles.description}>{project.description}</p>
//                     <button
//                         style={styles.actionBtn}
//                         onClick={() => navigate('/')}
//                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#555555'}
//                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#111111'}
//                     >
//                         Back to Projects
//                     </button>
//                 </section>

//             </div>
//         </div>
//     );
// };

// export default ProjectDetails;


import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ProjectDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { project } = location.state || {};
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    if (!project) {
        return <div style={{ padding: '100px', textAlign: 'center' }}>Project data missing.</div>;
    }

    return (
        <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh', padding: '50px 0 80px 0' }}>
            <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px' }}>

                {/* Back Link */}
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        background: 'none', border: 'none', color: '#6E7270',
                        cursor: 'pointer', fontFamily: "'Cinzel', serif",
                        textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '40px'
                    }}
                >
                    ← Back to Projects
                </button>

    <div style={{ marginBottom: '60px' }}>
                    <h1 style={{ fontFamily: "'Cinzel', serif", fontSize: '2.5rem', fontWeight: '400', textTransform: 'uppercase', margin: '0 0 10px 0' }}>
                        {project.title}
                    </h1>

                    <p style={{ color: '#D4AF37', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.9rem', margin: '0 0 30px 0' }}>
                        {project.category} — {project.location}
                    </p>

                    {/* ==================== SIDE-BY-SIDE DESCRIPTION & REVIEW ROW ==================== */}
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: isMobile ? '30px' : '60px',
                        width: '100%'
                    }}>

                        {/* Left Side: Description */}
                        <div style={{ flex: '1.2' }}>
                            <p style={{
                                color: '#6E7270',
                                lineHeight: '1.8',
                                fontSize: '0.95rem',
                                fontFamily: "'Cinzel', Georgia, serif",
                                fontWeight: '400',
                                letterSpacing: '1px',
                                margin: 0
                            }}>
                                {project.description}
                            </p>
                        </div>

                        {/* Right Side: Client Review & Name */}
                        {project.clientReview && (
                            <div style={{
                                flex: '1',
                                paddingLeft: isMobile ? '16px' : '24px',
                                borderLeft: '2px solid #D4AF37', // Elegant gold accent separator
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                                boxSizing: 'border-box'
                            }}>
                                <p style={{
                                    color: '#2C302E',
                                    fontSize: '1.1rem',
                                    fontStyle: 'italic',
                                    lineHeight: '1.6',
                                    fontFamily: "Georgia, 'Times New Roman', serif",
                                    margin: 0
                                }}>
                                    "{project.clientReview}"
                                </p>

                                {project.clientName && (
                                    <p style={{
                                        fontFamily: "'Cinzel', 'Georgia', serif",
                                        fontSize: '0.85rem',
                                        fontWeight: '600',
                                        textTransform: 'uppercase',
                                        letterSpacing: '2px',
                                        color: '#D4AF37',
                                        margin: 0
                                    }}>
                                        — {project.clientName}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Project Header */}
                {/* <div style={{ marginBottom: '60px' }}>
                    <h1 style={{ fontFamily: "'Cinzel', serif", fontSize: '2.5rem', fontWeight: '400', textTransform: 'uppercase', margin: '0 0 10px 0' }}>
                        {project.title}
                    </h1>
                    <p style={{ color: '#D4AF37', textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.9rem', margin: '0 0 20px 0' }}>
                        {project.category} — {project.location}
                    </p>
                    <p style={{ maxWidth: '800px', color: '#6E7270', lineHeight: '1.8', fontSize: '1rem' }}>
                        {project.description}
                    </p> 
                    <p style={{
                        maxWidth: '800px',
                        color: '#6E7270',
                        lineHeight: '1.8',
                        fontSize: '1rem',
                        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                        fontWeight: '300', // Light weight for an elegant, architectural feel
                        letterSpacing: '0.5px' // Delicate letter spacing to match your luxury aesthetic
                    }}>
                        {project.description}
                    </p>
                    <p style={{
                        maxWidth: '800px',
                        color: '#6E7270',
                        lineHeight: '1.8',
                        fontSize: '0.95rem',
                        fontFamily: "'Cinzel', Georgia, serif",
                        fontWeight: '400',
                        letterSpacing: '1px'
                    }}>
                        {project.description}
                    </p>
                </div> */}

                {/* ==================== PHOTO GALLERY WITH TIGHT SPACING ==================== */}
                {/* <div style={{
                    display: 'grid',
                    // Creates a clean, responsive masonry-style layout
                    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
                    gap: '6px', // This tight gap is what minimizes space between images
                    width: '100%'
                }}>
                    {project.gallery.map((imagePath, index) => (
                        <div 
                            key={index} 
                            style={{
                                overflow: 'hidden',
                                height: '380px',
                                background: '#F5F5F5',
                                transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.99)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        >
                            <img 
                                src={imagePath} 
                                alt={`${project.title} Detail ${index + 1}`} 
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display: 'block'
                                }}
                            />
                        </div>
                    ))}
                </div> */}
                {/* ==================== PHOTO GALLERY WITH NATURAL ASPECT RATIOS ==================== */}
                <div style={{
                    maxWidth: '1400px',
                    margin: '0 auto',
                    padding: '0 24px'
                }}>
                    <div style={{
                        columnCount: window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 2, // 3 columns for desktop, 2 for tablet, 1 for mobile
                        columnGap: '12px', // Tight, crisp spacing between columns
                        width: '100%'
                    }}>
                        {project.gallery.map((imagePath, index) => (
                            <div
                                key={index}
                                style={{
                                    breakInside: 'avoid', // Crucial: prevents images from breaking across columns
                                    marginBottom: '12px', // Equal spacing matching column gap
                                    overflow: 'hidden',
                                    borderRadius: '4px', // Slightly rounded for refined design
                                    transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                                    cursor: 'pointer',
                                    background: '#FDFDFD',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.015)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <img
                                    src={imagePath}
                                    alt={`${project.title} Detail ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: 'auto', // Keeps the exact native aspect ratio
                                        display: 'block',
                                        objectFit: 'contain' // No cropping
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* ==================== LARGE PARALLAX PHOTO GALLERY ==================== */}
                {/* <div style={{
                    width: '100%',
                    margin: '0 auto',
                    padding: '0 0 60px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px' // Tight but clean spacing between large panels
                }}>
                    {project.gallery.map((imagePath, index) => (
                        <div
                            key={index}
                            className="parallax-gallery-item"
                            style={{
                                width: '100%',
                                // Generous, large height for desktop lookbook feel
                                height: window.innerWidth < 768 ? '45vh' : '75vh',
                                position: 'relative',
                                overflow: 'hidden',
                                background: '#F9F9F9',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
                            }}
                        >

                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundImage: `url(${imagePath})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    // True premium parallax scrolling on desktop, standard clean scroll on mobile
                                    backgroundAttachment: window.innerWidth < 768 ? 'scroll' : 'fixed',
                                    transition: 'transform 0.4s ease'
                                }}
                            />
                        </div>
                    ))}
                </div> */}

                {/* ==================== HIGH-END EDITORIAL PARALLAX GRID ==================== */}
                {/* <div style={{
                    maxWidth: '1400px',
                    margin: '0 auto',
                    padding: '0 24px 80px 24px'
                }}>
                    <div style={{
                        display: 'grid',
                        // 2 spacious columns on desktop/tablet, 1 column on mobile
                        gridTemplateColumns: window.innerWidth < 992 ? '1fr' : '1fr 1fr',
                        // Tight but professional structural spacing
                        gap: '16px',
                        width: '100%'
                    }}>
                        {project.gallery.map((imagePath, index) => {
                            // Alternate card heights to complement mixed portrait and landscape photos
                            // This gives a dynamic, custom editorial grid look
                            const isTallCard = index % 3 === 0;
                            const desktopHeight = isTallCard ? '650px' : '450px';
                            const mobileHeight = '350px';

                            return (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        height: window.innerWidth < 768 ? mobileHeight : desktopHeight,
                                        overflow: 'hidden',
                                        background: '#F9F9F9',
                                        border: '1px solid rgba(44, 48, 46, 0.05)',
                                        transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.99)'}
                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                >

                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundImage: `url(${imagePath})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            // Fixed background creates the premium parallax reveal effect on scroll
                                            backgroundAttachment: window.innerWidth < 768 ? 'scroll' : 'fixed',
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default ProjectDetail;


// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const ProjectDetail = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { project } = location.state || {};

//     // Track mobile view state for responsive flex layout
//     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // useEffect(() => {
    //     const handleResize = () => setIsMobile(window.innerWidth < 768);
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

//     if (!project) {
//         return <div style={{ padding: '100px', textAlign: 'center' }}>Project data missing.</div>;
//     }

//     return (
//         <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh', padding: '120px 0 80px 0' }}>
//             <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 24px' }}>

//                 {/* Back Link */}
//                 <button
//                     onClick={() => navigate(-1)}
//                     style={{
//                         background: 'none', border: 'none', color: '#6E7270',
//                         cursor: 'pointer', fontFamily: "'Cinzel', serif",
//                         textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '40px'
//                     }}
//                 >
//                     ← Back to Projects
//                 </button>

//                 {/* Project Header */}
            

//                 {/* ==================== PHOTO GALLERY WITH NATURAL ASPECT RATIOS ==================== */}
//                 <div style={{
//                     maxWidth: '1400px',
//                     margin: '0 auto',
//                     padding: '0 24px'
//                 }}>
//                     <div style={{
//                         columnCount: window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 3,
//                         columnGap: '12px',
//                         width: '100%'
//                     }}>
//                         {project.gallery.map((imagePath, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     breakInside: 'avoid',
//                                     marginBottom: '12px',
//                                     overflow: 'hidden',
//                                     borderRadius: '4px',
//                                     transition: 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                     cursor: 'pointer',
//                                     background: '#FDFDFD',
//                                     boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.015)'}
//                                 onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                             >
//                                 <img
//                                     src={imagePath}
//                                     alt={`${project.title} Detail ${index + 1}`}
//                                     style={{
//                                         width: '100%',
//                                         height: 'auto',
//                                         display: 'block',
//                                         objectFit: 'contain'
//                                     }}
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ProjectDetail;